import { Grid } from '@mui/material';
import AdminMetricCard from '../shared/AdminMetricCard';

interface Metric {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  color?: string;
  trend?: {
    value: number;
    label: string;
    direction: 'up' | 'down';
  };
}

interface MetricsGridProps {
  metrics: Metric[];
  loading?: boolean;
}

/**
 * MetricsGrid - Responsive grid of metric cards
 *
 * Displays KPI cards in a responsive grid layout
 * - 4 columns on xl screens
 * - 3 columns on lg screens
 * - 2 columns on md screens
 * - 1 column on sm/xs screens
 */
export default function MetricsGrid({ metrics, loading }: MetricsGridProps) {
  return (
    <Grid container spacing={3}>
      {metrics.map((metric, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
          <AdminMetricCard {...metric} loading={loading} />
        </Grid>
      ))}
    </Grid>
  );
}
